import { Grid, Typography } from 'gu-ui-kit'
import React, { useEffect, useState } from 'react'
import styles from 'modules/Services/CampaignsEditor/subcomponents/BudgetEditor/budget-editor.module.scss'
import format from 'utils/dateFns/format'
import clsx from 'clsx'
import Dates from 'modules/Services/CampaignsEditor/subcomponents/BudgetEditor/subcomponents/ModifyList/configs/subcomponents/Dates'
import { useTranslation } from 'react-i18next'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { StatusBadge } from 'modules/Services/CampaignsEditor/subcomponents/BudgetEditor/subcomponents/ModifyList/configs/subcomponents/StatusBadge'
import isEmpty from 'lodash/isEmpty'

const datesConfig = (props) => {
  const { updateRow, resource } = props
  const breakpoints = useBreakpoint()
  const { t } = useTranslation()
  const [columnVisibility, setColumnVisibility] = useState({})

  useEffect(() => {
    if (!breakpoints.md) {
        setColumnVisibility({
          name_and_dates: true,
          name: false,
          dates: false,
          rowState: false,
        })
    } else if (!breakpoints.lg) {
        setColumnVisibility({
          name_and_dates: false,
          rowState: false,
        })
    } else {
        setColumnVisibility({ name_and_dates: false })
    }
  }, [breakpoints])

  const setStartDate = (row, value) =>
    updateRow(row.external_id, { date_start: format(value, 'yyyy-MM-dd') })

  const setEndDate = (row, value) =>
    updateRow(row.external_id, { date_end: format(value, 'yyyy-MM-dd') })

  return {
    columns: [
      {
        id: 'name_and_dates',
        header: t(
          'campaigns_editor::budget_editor.table.head.name_and_dates.label',
          { context: resource },
        ),
        cell: ({ row: { original } }) => {
          const { name, rowState } = original

          return (
            <Grid
              direction={'column'}
              gap={8}
              alignItems="flex-start"
              className={clsx({
                [styles['modified']]:
                  rowState?.touched === true || rowState?.updated === true,
                [styles['modified_error']]:
                  rowState?.error || !isEmpty(rowState?.errors),
              })}
            >
              <Grid
                className={styles['budget-editor__edit-name-container']}
                fluid={false}
                direction="column"
                alignItems="flex-start"
                justifyContent="start"
                gap={16}
              >
                <Typography variant={'Body-3'} component={<div>{name}</div>} />

                {!breakpoints.md && (
                  <StatusBadge
                    status={
                      rowState?.error
                        ? 'error'
                        : rowState?.updated
                        ? 'updated'
                        : ''
                    }
                  />
                )}

                <Dates
                  original={original}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                />
              </Grid>
            </Grid>
          )
        },
      },
      {
        id: 'name',
        header: t('campaigns_editor::budget_editor.table.head.name.label', {
          context: resource,
        }),
        cell: ({
          row: {
            original: { name, rowState },
          },
        }) => (
          <Grid
            direction={'column'}
            gap={8}
            alignItems="flex-start"
            className={clsx({
              [styles['modified']]:
                rowState?.touched === true || rowState?.updated === true,
              [styles['modified_error']]:
                rowState?.error || !isEmpty(rowState?.errors),
            })}
          >
            <Grid
              className={styles['budget-editor__edit-name-container']}
              fluid={false}
              direction="column"
              alignItems="flex-start"
              justifyContent="start"
              gap={4}
            >
              <Typography variant={'Body-3'} component={<div>{name}</div>} />

              {!breakpoints.lg && <StatusBadge rowState={rowState} />}
            </Grid>
          </Grid>
        ),
      },
      {
        id: 'dates',
        header: t('campaigns_editor::budget_editor.table.head.dates.label'),
        cell: ({ row: { original } }) => {
          return (
            <Grid gap={16} wrap={'nowrap'}>
              <Dates
                original={original}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
              />
            </Grid>
          )
        },
      },
      {
        id: 'rowState',
        header: ' ',
        size: 100,
        cell: ({
          row: {
            original: { rowState },
          },
        }) => <StatusBadge rowState={rowState} placement={'left'} />,
      },
    ],
    showHeader: true,
    showFooter: false,
    className: styles['budget-editor__table'],
    getRowId: ({ external_id }) => external_id,
    state: {
      columnVisibility,
    },
    ...props,
  }
}

export { datesConfig }

